export class OwnerIdeasDeleteRequest {
  ideaId!: string
}
